import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectRolesService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@Component({
    selector: 'member-group-roles-button-renderer',
    templateUrl: './member-group-roles-button-renderer.component.html',
    styleUrls: ['./member-group-roles-button-renderer.component.scss'],
    standalone: false
})
export class MemberGroupRolesButtonRendererComponent implements ICellRendererAngularComp {

  params: any;
  isUserInGroupRole: boolean = false;
  isUserDisplayed: boolean = false;

  constructor(private projectRolesService: ProjectRolesService,
    private translate: TranslateService,
    private tenantService:TenantService,
    private oauthService: OAuthServiceService,
    private notificationService: NotificationService) { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const rowData = this.params.node.data;
    //console.log("------> member-group-roles-button-renderer: agInit rowData = ", rowData)
    if(rowData != undefined && rowData != null){
      this.isUserInGroupRole = rowData.isRoleMember;
      this.isUserDisplayed = (rowData.userName != null && rowData.userName != undefined && rowData.userName.trim() != "");
    }
    // else {
    //   console.log("------> member-group-roles-button-renderer: agInit params.data = ", this.params.data)
    //   this.isUserInGroupRole = this.params.data.isRoleMember;
    // }
    this.refresh(params);
  }

  changeCheckbox(event: any) {
    this.params.node.data.isRoleMember = !this.params.node.data.isRoleMember;
    this.params.node.data.isChanged = !this.params.node.data.isChanged;
    console.log("------> member-group-roles-button-renderer: changeCheckbox: params = ", this.params.node.data)
    if (this.params.onClick) {
      this.params.onClick(this.params.node.data);
    }
  }
  // deleteUserFromGroupRole() {
  //   const rowData = [this.params.node.data];
  //   //if(!this._forTenantDb){
  //     //this.deleteFromMaindb(rowData);
  //   //}
  //   //else{
  //     this.deleteFromTenantdb(rowData);
  //   //}     
  // }

  // deleteFromTenantdb(rowData: any[]) {
  //   console.log("------>user-group-roles-button-renderer: deleteFromTenantdb")
  //   console.log("rowData = ", rowData[0])
  //   let db:string = this.tenantService.currentTenantName;
  //  this.tenantService.deleteUserFromGroupRole(db, this.tenantService.projectId, rowData[0].roleId, rowData[0].userId).subscribe({
  //     next: () => {
  //       this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLE"]}`);
  //       this.params.api.refreshInfiniteCache();
  //     },
  //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLEERROR"]}`)
  //   });
  // }

  // deleteFromMaindb(rowData: any[]) {
  //   console.log("------>user-group-roles-button-renderer: deleteFromMaindb")
  //   this.projectRolesService.deleteUserFromGroupRole(rowData[0].projectId, rowData[0].roleId, rowData[0].userId).subscribe({
  //     next: () => {
  //       this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLE"]}`);
  //       this.params.api.refreshInfiniteCache();
  //     },
  //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLEERROR"]}`)
  //   });
  // }
}
